import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

const Dropzone = ({ onFileSelect }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // ← Nuevo estado
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      setSelectedFile(file);
      if (onFileSelect) onFileSelect(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const file = files[0];
      setSelectedFile(file);
      if (onFileSelect) onFileSelect(file);
    }
  };

  // Función opcional para limpiar el archivo seleccionado
  const handleClear = () => {
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
    if (onFileSelect) onFileSelect(null);
  };

  let bgColor;
  if (isDragging) {
    bgColor = '#e6f4ff';
  } else if (selectedFile) {
    bgColor = '#f0fff4';
  } else {
    bgColor = '#fafafa';
  }

  let contenido;
  if (selectedFile) {
    contenido = (
      <div>
        <strong>Archivo seleccionado:</strong>
        <p style={{ margin: '8px 0', color: '#2e7d32' }}>{selectedFile.name}</p>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleClear();
          }}
          style={{
            marginTop: '8px',
            padding: '4px 8px',
            fontSize: '14px',
            color: '#d32f2f',
            background: 'none',
            border: '1px solid #d32f2f',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Eliminar
        </button>
      </div>
    );
  } else if (isDragging) {
    contenido = <p>Suelta el archivo aquí...</p>;
  } else {
    contenido = <p>Arrastra un archivo aquí o haz clic para seleccionar</p>;
  }

  return (
    <div
      role="presentation"
      style={{
        border: '2px dashed #ccc',
        borderRadius: '8px',
        padding: '40px',
        textAlign: 'center',
        backgroundColor: bgColor,
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        position: 'relative',
      }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <button
        type="button"
        onClick={handleClick}
        style={{
          background: 'none', border: 'none', padding: 0, cursor: 'pointer',
          width: '100%', height: '100%', display: 'block', color: 'inherit', font: 'inherit',
        }}
      >
        {contenido}
      </button>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileInputChange}
      />
    </div>
  );
};

Dropzone.propTypes = {
  onFileSelect: PropTypes.func,
};

export default Dropzone;